export default __webpack_public_path__ + "static/media/info.18318dae.svg";